import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idFormat',
})
export class idFormatPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value || value === null || value === undefined) {
      return '';
    }

    const raw = value.slice(0, 7).padStart(7, '0');

    const part1 = raw.slice(0, 3);
    const part2 = raw.slice(3, 7);
    return `${part1}-${part2}`;
  }
}
